import { ComponentType } from '../../registries/types/propTypes';
import type { OurPromisesProps } from '../../../components/OurPromises/OurPromises';
import type { OurPromisesItemProps } from '../../../components/OurPromises/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformOurPromises = (data: CMSTransformerDataType): OurPromisesProps => {
  const ourPromisesdata: OurPromisesItemProps[] = [];
  const ourPromises = Array.isArray(data.amway_promises) ? data.amway_promises[0] : data.amway_promises;

  ourPromises?.images?.forEach((item: CMSTransformerDataType) => {
    const imageTitle = item.title;
    const imagesData = item.images.images.map((image: CMSTransformerDataType) => ({
      url: image.image.url,
      altText: image.alt_text,
      viewport: image.viewport,
    }));
    ourPromisesdata.push({
      imageTitle,
      imagesData,
    });
  });
  return {
    componentType: ComponentType.amway_promises,
    title: ourPromises.display_title,
    ourPromisesdata: ourPromisesdata,
  };
};

export default transformOurPromises;
